<template>
  <confirmationModal
    v-bind="$attrs"
    v-on="$listeners"
    title="Unsaved Changes"
    @closeModal="closeModal"
  >
    <p class="subtitle-1">
      You have unsaved changes. Are you sure you want to leave this page?
    </p>
    <template #buttons>
      <qvoButton text @click="closeModal">Cancel</qvoButton>
      <qvoButton warning @click="$emit('confirmLeave')">Leave</qvoButton>
    </template>
  </confirmationModal>
</template>
  
<script>
import qvoButton from "@/qux-common/qux22/components/molecules/button";
import confirmationModal from "@/components/confirmation-modal";

export default {
  name: "UnsavedChangesModal",
  components: {
    confirmationModal,
    qvoButton,
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
  },
};
</script>
  
<style lang="scss" scoped>
</style>